import _ from 'lodash';
import PivotCube from './PivotCube';

export class PivotData {
  constructor(state) {
    this._init(state);
  }

  _init(state) {
    const {data, category, rows, columns, measures} = state;

    const columnFilter = column => !column.hidden;
    const fieldToName = v => ({name: v.field, expand: v.expand || false});

    const pivotCube = new PivotCube(measures, columns, rows);
    this.dataSource = {
      data,
      columns: _.map(_.filter((category ? [category].concat(columns) : columns), columnFilter), fieldToName),
      rows: _.map(_.filter(rows, columnFilter), fieldToName),
      schema: {
        cube: {
          measures: pivotCube.measures,
          dimensions: pivotCube.dimensions
        }
      },
      measures: pivotCube.listMeasures()
    };
    this.type = 'pivot';
  }
}
